import { Component, inject, ViewChild } from '@angular/core'
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  RouterOutlet,
  Router,
  type Event,
} from '@angular/router'
import { TitleService } from './core/service/title.service'
import {
  NgProgressComponent,
  NgProgressModule,
  type NgProgressRef,
} from 'ngx-progressbar'
import { AuthenticationService } from './core/service/auth.service'
import { PaginacaoLoadingComponent } from './components/paginacao-loading/paginacao-loading.component'
import { PaginacaoLoadingService } from './core/service/paginacao-loading.service'
import { ThemeService } from './core/service/theme.service'

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgProgressModule, PaginacaoLoadingComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {

  progressRef!: NgProgressRef

  @ViewChild(NgProgressComponent)
  progressBar!: NgProgressComponent

  private titleService = inject(TitleService)
  private router = inject(Router)
  private authService = inject(AuthenticationService)
  private paginacaoLoading = inject(PaginacaoLoadingService)
  private themeService = inject(ThemeService)

  constructor() {
    this.router.events.subscribe((event: Event) => {
      this.checkRouteChange(event)
    })
  }

  ngOnInit(): void {
    this.themeService
    this.authService.restoreSession()
    this.titleService.init()
  }

  checkRouteChange(routerEvent: Event) {
    if (routerEvent instanceof NavigationStart) {
      this.progressBar.start()
      this.paginacaoLoading.resetar()
    }

    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        this.progressBar.complete()
      }, 200)
    }
  }
}
